import { Button } from '@/components/Button';
import Loading from '@/components/Loading';
import { useNavigate } from '@tanstack/react-router';
import { MdKeyboardArrowLeft } from 'react-icons/md';

type Props = {
  listPath?: '/agent/linked_accounts' | '/agent/linked_accounts/shared';
};

export default function LinkedAccountLoading({ listPath = '/agent/linked_accounts' }: Props) {
  const navigate = useNavigate();

  const handleBackToList = () => {
    navigate({ to: listPath });
  };

  return (
    <div className="relative mt-[-60px] flex min-h-screen flex-col items-center justify-center">
      <Loading size="medium" />
      <p className="text-body-sm">同期中</p>
      <Button color="secondary" className="mt-lg" onClick={handleBackToList}>
        <MdKeyboardArrowLeft size={20} />
        一覧へ戻る
      </Button>
    </div>
  );
}
